import toast from "react-hot-toast";
import { PRODUCTO_LINEA } from "./constants";
import { charCodes } from "./constants";
import getBloqueInfo from "../services/getBloqueInfo";

const getURLFromImageBackground = (content) => {
  return content.find(item => item.url).url;
}

const formatUrl = (url) => {
  let formattedUrl = url.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  formattedUrl = formattedUrl
    .replace(/[¿¡?!,:;]+/g, '')
    .replace(/[|/ _]/g, '-')
    .replace(/--+/g, '-')
    .replace(/[#$*]/g, '')
    .replace(/\.$/, '');
  formattedUrl = formattedUrl.replace(/[^a-zA-Z0-9]+$/, ''); 
  return formattedUrl.toLowerCase();
};

const formatDescription = (description) => {
  const maxLength = 155;
  if (description?.length <= maxLength) {
    return description;
  }
  const lastPeriodIndex = description?.lastIndexOf('.', maxLength);
  const truncatedDescription = description?.slice(0, lastPeriodIndex);
  return `${truncatedDescription}.`;
}

const URLTypeProduct = (type) => {
  return type === PRODUCTO_LINEA ? 'producto' : 'producto-especial';
}

const onlyPositiveInputs = (event) => {
  const charCode = event.charCode;
  if (charCode !== charCodes.charCodeBackspace && (charCode < charCodes.charCodeZero || charCode > charCodes.charCodeNine)) {
    event.preventDefault();
  }
}

const filterCategories = (arr) => {
  const categoriasMap = arr
    .filter(item => item.title)
    .map((item) => {
      return [item.title, item];
    });
  return [...new Map(categoriasMap).values()];
}

const getInfoBloque = async () => {
  try {
    const { data } = await getBloqueInfo();
    return data?.allBloqueInfo;
  } catch (error) {
    toast.error('Error al obtener la informacion de los bloques')
  }
}

const sortAndFilterProducts = (products, productType) => {
  return products
    .filter((product) => product.type === productType)
    .sort(
      (productPosA, productPosB) =>
        productPosA?.position?.find((obj) => obj)?.product - productPosB?.position?.find((obj) => obj)?.product
    )
}

const extractIdAndPosition = (elements) => {
  return elements.map(element => ({
    _id: element._id,
    position: element.position
  }));
};

const sortElementsByPosition = (elements, elementName) => {
  return elements
    .sort(
    (elementPosA, elementPosB) =>
      elementPosA?.position?.find((obj) => obj)?.[elementName] - elementPosB?.position?.find((obj) => obj)?.[elementName]
  )
}

export {
  getURLFromImageBackground,
  formatUrl,
  formatDescription,
  URLTypeProduct,
  onlyPositiveInputs,
  filterCategories,
  getInfoBloque,
  sortAndFilterProducts,
  extractIdAndPosition,
  sortElementsByPosition
};
